<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <tabela
          :item="item"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="
            processamentosExpirados = $event,
            getAll()
          "
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProjecaoBrrService from '@/services/ProjecaoBrrService';
import pusherMixins from '@/mixins/pusherMixins';
import tourMixins from '@/mixins/tourMixins';

export default {

  components: {
    Tabela: () => import('@/components/projecaoBrr/Tabela.vue')
  },
  mixins: [pusherMixins, tourMixins],

  data: () => ({
    item: [],
    loading: false,
    processamentosExpirados: false,
    arrTour: [
      {
        element: '#btn-nova-projecao-brr',
        intro: 'Clicando neste botão você poderá criar novas Projeções de Brr.',
        scrollTo: 'tooltip',
        position: 'right'
      },
      {
        element: '#projecao-brr-search',
        intro: 'Neste campo você poderá pesquisar por Projeções de Brr já existentes.',
        scrollTo: 'tooltip',
        position: 'bottom'
      },
      {
        element: '#action-download-projecao-brr',
        intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de sua Projeção de Brr.',
        scrollTo: 'tooltip',
        position: 'left'
      },
      {
        element: '#action-edit-projecao-brr',
        intro: 'Clicando neste ícone você poderá editar sua Projeção de Brr.',
        scrollTo: 'tooltip',
        position: 'left'
      },
      {
        element: '#action-more-projecao-brr',
        intro: 'Aqui você acessa outras opções para sua Projeção de Brr, como ver mais detalhes, executá-lo novamente, duplica-ló ou deletá-lo.',
        scrollTo: 'tooltip',
        position: 'left'
      }
    ]
  }),

  mounted() {
    this.subscribe();
    this.getAll();
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('reload-pag-projecao-brr', () => {
        this.getAll();
      });
    },

    getAll() {
      this.loading = true;

      ProjecaoBrrService.getAll(this.processamentosExpirados)
        .then(response => this.item = response.data.data)
        .catch (error => {
          this.$toast.error('Erro ao recuperar projeções de brr.', '', {position:'topRight'});
        }) 
        .finally(() => {
          this.loading = false
          this.iniciarTourPagina();
        });
    },
    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      let arrTourFormatted = this.item.length ? this.arrTour : this.arrTour.splice(0, 2);
      this.iniciarTour(arrTourFormatted);
    }
  }
};
</script>